// extracted by mini-css-extract-plugin
export default {"root":"GhI3ydtFHGuLPUBi7Snj"};